import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { ActionName, ModuleName } from '../models/access.model';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private permissionSet = new Set<string>();

  constructor(private session: SessionService) {
    this.buildCache();
  }

  private buildCache() {
    const access = this.session.access();

    for (const mod of access) {
      if (!mod.moduleStatus) continue;

      for (const action of mod.actions) {
        if (action.status) {
          this.permissionSet.add(`${mod.moduleName}:${action.actionName}`);
        }
      }
    }
  }

  has(module: string, action: string): boolean {
    const access = this.session.access();

    const mod = access.find(
      (m) => m.moduleName.toUpperCase() === module.toUpperCase(),
    );
    if (!mod) return false;

    return mod.actions.some(
      (a) => a.actionName.toUpperCase() === action.toUpperCase(),
    );
  }

  hasAnyInModule(moduleName: string): boolean {
    // Convertimos a Mayúsculas para que coincida con el Set
    const searchKey = moduleName.toUpperCase() + ':';

    for (const key of this.permissionSet) {
      // Si alguna llave en el Set empieza con "USUARIOS:", significa que tiene acciones
      if (key.toUpperCase().startsWith(searchKey)) {
        return true;
      }
    }
    return false;
  }

  // importante cuando actualizas permisos en sesión
  refresh() {
    this.permissionSet.clear();
    this.buildCache();
  }
}
